export const APP_STORE_URL =
  "https://apps.apple.com/us/app/mendly-self-talk-tracker/id6761359982";
